import { graphql } from "gatsby";
import { MDXRenderer } from "gatsby-plugin-mdx";
import React from "react";
import { Box } from "theme-ui";
import SEO from "react-seo-component";
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { SideScroller } from "../components/scroller"
import { LayoutComponentBackground } from "../components/layout-component-background"
import karnovImage from '../../images/karnov.png';
import { CountDown } from "../components/countDown";

export default function PostPage({ data }) {
  const {
    body,
    slug,
    excerpt,
    frontmatter: { title, date, scrollerComponent, scrollerComponentProps, layoutBackgroundProps, layoutBackgroundSubComponent },
  } = data.mdx;

  console.log(data);

    const {
        title: siteTitle,
        siteUrl,
        siteLanguage,
        siteLocale,
        twitterUsername,
        authorName,
    } = useSiteMetadata();

  return (
    <>
    {/* <CountDown/> */}
      <SEO
        title={title}
        titleTemplate={siteTitle}
        titleSeparator={`-`}
        image={karnovImage}
        description={excerpt}
        pathname={`${siteUrl}${slug}`}
        article={true}
        siteLanguage={siteLanguage}
        siteLocale={siteLocale}
        twitterUsername={twitterUsername}
        author={authorName}
        datePublished={date}
        dateModified={new Date(Date.now()).toISOString()}
      />

{/* //fontSize="4xl" */}
      <Box as="h1" variant="styles.h1" > 
        {title}
      </Box>

      {!scrollerComponent ? <></> : <Box> <SideScroller childData={scrollerComponent} properties={scrollerComponentProps} /> </Box>}

      {/* <LayoutComponentBackground properties={layoutBackgroundProps} layoutBackgroundSubComponent={layoutBackgroundSubComponent}/> */}
      <MDXRenderer>{body}</MDXRenderer>
      
    </>
  );
}

export const query = graphql`
  query POST_BY_SLUG($slug: String) {
    mdx(slug: {eq: $slug}) {
      id
      slug
      body
      excerpt
      frontmatter {
        date
        title
        scrollerComponent
        scrollerComponentProps {
          alignedTo
          width
          height
        }
        layoutBackgroundProps {
          color1
          color2
          altcolor1
          altcolor2
        }
        layoutBackgroundSubComponent
      }
    }
  }
`;
